import {get_media, useRefState} from "../utils";
import {Station, Streams} from "../PlayerReducer";
import {useEffect, useState} from "react";
import { Sources } from './Source';


export const useSrc = (props:{
    streams: Streams,
    station: Station|null
})=>{

    const [srcs, setSrcs] = useRefState<undefined|false|Sources>(undefined);

    useEffect(()=> {
        const station = props.station;
        const streams = props.streams;
        if (!station) {
            setSrcs(false);
            return;
        }

        const stream = Object.keys(streams).filter(i => streams[i].stationId === station.stationId).map(i => streams[i])[0];

        if (stream.type === 'm3u') {
            (async () => {
                try {
                    const promiseText = await fetch(stream.url);
                    const text = await promiseText.text();
                    const matchedd = text.match(/^(?!#)(?!\s).*$/mg);
                    const urls:Sources = [];
                    if (matchedd) {
                        matchedd.forEach((element) => {
                            element = element.trim()
                            if (element)
                                urls.push(get_media(element, undefined));
                        });
                    }
                    if (!urls.length)
                        setSrcs(false);
                    else
                        setSrcs(urls);

                }
                catch (e) {
                    setSrcs(false);
                }
            })();
        } else {
            const urls:Sources = [];
            urls.push(get_media(stream.url, stream.type));
            setSrcs(urls);
        }
    }, [props.station, props.streams]);
    return srcs;
}